/* NOOT — Set / Top / Bottom selector.
   Points Dawn's own <variant-selects> at the chosen piece's product (variant data + URL),
   so Dawn itself re-renders price, compare-at, sale badge and the Add to cart / Sold out state
   from the real standalone product, and puts the real variant id into the product form. */
if (!customElements.get('set-piece-selector')) {
  customElements.define(
    'set-piece-selector',
    class SetPieceSelector extends HTMLElement {
      connectedCallback() {
        try {
          this.pieces = JSON.parse(this.querySelector('[data-set-pieces]').textContent);
        } catch (e) {
          this.pieces = {};
        }
        this.current = 'set';
        this.addEventListener('change', (event) => {
          const input = event.target;
          if (!input || input.name !== this.dataset.name) return;
          event.stopPropagation();
          this.select(input.value);
        });
      }

      getVariantSelects() {
        return document.getElementById(`variant-selects-${this.dataset.section}`);
      }

      remember(vs) {
        if (this.original) return;
        this.original = {
          variants: vs.getVariantData(),
          url: vs.dataset.url,
          updateUrl: vs.dataset.updateUrl,
        };
      }

      select(key) {
        const vs = this.getVariantSelects();
        if (!vs || typeof vs.onVariantChange !== 'function') return;
        this.remember(vs);

        let variants;
        let url;
        if (key === 'set' || !this.pieces[key]) {
          variants = this.original.variants;
          url = this.original.url;
          if (this.original.updateUrl === undefined) delete vs.dataset.updateUrl;
          else vs.dataset.updateUrl = this.original.updateUrl;
        } else {
          // Piece images are not in this page's gallery, so never ask Dawn to switch media.
          variants = this.pieces[key].variants.map((v) => Object.assign({}, v, { featured_media: null }));
          url = this.pieces[key].url;
          // Keep the address bar on the Set page.
          vs.dataset.updateUrl = 'false';
        }

        this.current = key;
        vs.variantData = variants;
        vs.dataset.url = url;
        this.refreshAvailability(vs, variants);
        vs.onVariantChange({ target: vs });
      }

      // Dawn only recomputes availability for the 2nd+ option, so mark every option value here.
      refreshAvailability(vs, variants) {
        const wrappers = Array.from(vs.querySelectorAll('.product-form__input'));
        const selected = wrappers.map((w) => {
          const checked = w.querySelector('input:checked');
          if (checked) return checked.value;
          const select = w.querySelector('select');
          return select ? select.value : null;
        });

        wrappers.forEach((wrapper, index) => {
          wrapper.querySelectorAll('input[type="radio"], option').forEach((el) => {
            const value = el.getAttribute('value');
            const available = variants.some((variant) => {
              if (!variant.available) return false;
              for (let i = 0; i < index; i++) {
                if (variant.options[i] !== selected[i]) return false;
              }
              return variant.options[index] === value;
            });
            if (el.tagName === 'INPUT') {
              el.classList.toggle('disabled', !available);
            } else if (window.variantStrings) {
              el.innerText = available
                ? value
                : window.variantStrings.unavailable_with_option.replace('[value]', value);
            }
          });
        });
      }
    }
  );
}
